import * as types from './types';

const INITIAL_STATE = {
  sites: [],
  siteGroups: [],
  selectedSites: [],
  report: null,
  loading: false,
  loadingReport: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.RECEIPTS_COLLECTIONS_REPORT_FORM_LOADING:
      return {
        ...state,
        loading: payload,
        loadingReport: false,
      };

    case types.RECEIPTS_COLLECTIONS_REPORT_SET_SELECTED_SITES:
      return {
        ...state,
        selectedSites: payload,
      };

    case types.RECEIPTS_COLLECTIONS_REPORT_GET_REPORT:
      return {
        ...state,
        report: payload,
      };

    case types.RECEIPTS_COLLECTIONS_REPORT_LOADING:
      return {
        ...state,
        loading: payload,
        loadingReport: payload,
      };

    case types.RECIEPTS_COLLECTIONS_REPORT_CLEAR_REPORT:
      return {
        ...state,
        report: null,
        error: null,
      };

    case types.RECEIPTS_COLLECTIONS_REPORT_ERROR:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/state/report/reducer.js